export const formatLabelEndereco = (data: any) => {
  const endereco = 'node' in data ? data.node : data

  return {
    name: `${endereco.logradouro}, IE: ${
      endereco.inscricaoEstadual ?? 'NÃO INFORMADA'
    } | ${endereco.atividadeFiscal ?? 'SEM ATIVIDADE FISCAL'}`,
    value: endereco.id
  }
}
